import { MHTTPCL } from "../../../services/http/http-client";
import { SETTINGS_URL } from "../../../services/common-urls";

export const LanguageSettingsService = {
  findLanguageSettingsData: ({
    user_name,
    password,
  }) => MHTTPCL.post(SETTINGS_URL, {
    section: 'usersetup',
    action: 'authenticate',
    redirect_to: 'languageSettingsTab',
    output: 'json',
    user_name,
    password,
  }).then(res => res.data),
  findI18NByName: (search) => MHTTPCL.post(SETTINGS_URL, {
    section: 'language',
    search,
    output: 'json',
  }),
  insertI18NEntry: ({
    textkey,
    i18n_section,
    en,
    de,
    fr,
    be,
    it,
    es,
    nl,
    pt,
    tr,
  }) => MHTTPCL.post(SETTINGS_URL, {
    section: 'language',
    action: 'add_i18n',
    textkey,
    i18n_section,
    en,
    de,
    fr,
    be,
    it,
    es,
    nl,
    pt,
    tr,
  })
}